import React, { useEffect, useState } from "react";
import SideNavLayout from "../../Sidenav/SideNavLayout";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ToastMessage from "../../utils/muitoast";
import dayjs from "dayjs";
import minMax from "dayjs/plugin/minMax";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import WDSFormModal from "../WDSformModal";
import WDSMergeFormModal from "../wdsmergemodal";
import FilterModal from "../Modals/FilterModal";
import CalendarDropdown from "./calendermodal";

import Calendar1 from "../../assets/Calender.svg";


import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(minMax);
const getCurrentWeekRange = () => {
  const today = dayjs();

  // Monday start
  const start = today.startOf("week").add(1, "day");

  // Sunday end
  const end = start.add(6, "day");

  return {
    startDate: start.toDate(),
    endDate: end.toDate(),
    key: "selection"
  };
};

const MergeDashboard = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const typeParam = queryParams.get("type") || "weekly";

  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [formView, setFormView] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showMergeBtn, setShowMergeBtn] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const Navigate=useNavigate()
  const [severity, setSeverity] = useState("success");
  const [activeModal, setActiveModal] = useState(null);

const [previewRows, setPreviewRows] = useState([]);
const [openMergePreview, setOpenMergePreview] = useState(false);
const [modalSelectedRows, setModalSelectedRows] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({
    dates: [],
    employees: [],
    jobs: [],
    formTypes: [],
    statuses: [],
    methods: []
  });

  const [openCalendar, setOpenCalendar] = useState(false);
const [selectedDateRange, setSelectedDateRange] = useState(getCurrentWeekRange);

  const [selectedEmployee, setSelectedEmployee] = useState("");
  // Universal search — matches across employee, job, form, method, observer, date.
  const [searchTerm, setSearchTerm] = useState("");

  const formTypeMap = {
    weekly: "Weekly Driver Form Dashboard",
    bbs: "Behavior Based Safety (BBS) Form Dashboard",
    shp: "Safety & Health Primary Audit Form Dashboard",
  };

  const fetchTableData = async () => {
    try {
      setLoader(true);
      const response = await api.get("/v1/forms/get");
      if (response.status === 200) {
        const filtered = response.data.filter((row) => {
          if (typeParam === "weekly") return row.form_type === "WDS";
          if (typeParam === "bbs") return row.form_type === "BBS";
          if (typeParam === "shp") return row.form_type === "SHP";
          return true;
        });
        setTableData(filtered);
        setFilteredData(filtered);
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    } finally {
      setLoader(false);
    }
  };
useEffect(()=>{
console.log(previewRows,'pree')
},[previewRows])
  useEffect(() => {
    fetchTableData();
  }, [typeParam]);

  useEffect(() => {
    const { dates, employees, jobs, formTypes, statuses, methods } = selectedFilters;
    const term = searchTerm.trim().toLowerCase();

    const filtered = tableData.filter(row => {
      const jsonDateObj = row.json_data?.find(obj => obj.Dates);
      const rowDate = jsonDateObj ? jsonDateObj.Dates : row.filled_date;

      const matchDate = dates.length === 0 || dates.includes(rowDate);
      const matchEmp = employees.length === 0 || employees.includes(`${row.emp_name} (${row.emp_id})`);
      const matchJob = jobs.length === 0 || jobs.includes(`${row.jobDescription} (${row.job_id})`);
      const matchForm = formTypes.length === 0 || formTypes.includes(row.form_type);
      const matchStatus = statuses.length === 0 || statuses.includes(row.status);
      const matchMethod = methods.length === 0 || methods.includes(row.method);

      // Universal search — scan every displayed field so the user can type
      // any partial employee/job/form/method/observer/date and narrow down.
      const matchSearch =
        term === "" ||
        [
          row.emp_name,
          row.emp_id,
          row.jobDescription,
          row.job_id,
          row.form_type,
          row.method,
          row.observer_name,
          rowDate,
        ]
          .filter((v) => v !== undefined && v !== null)
          .some((v) => String(v).toLowerCase().includes(term));

      return matchDate && matchEmp && matchJob && matchForm && matchStatus && matchMethod && matchSearch;
    });

    setFilteredData(filtered);
  }, [tableData, selectedFilters, searchTerm]);

  const handleCheckboxChange = (rowId) => {
    setSelectedRows((prev) =>
      prev.includes(rowId) ? prev.filter((id) => id !== rowId) : [...prev, rowId]
    );
  };

  // const validateWDSSelection = (rows) => {
  //   if (rows.length === 0) return false;
  //   if (!rows.every((r) => r.form_type === "WDS")) return false;

  //   const empSet = new Set(rows.map((r) => r.emp_id));
  //   if (empSet.size !== 1) return false;

  //   const dates = rows.map((r) => new Date(r.filled_date));
  //   const minDate = new Date(Math.min(...dates));
  //   const startOfWeek = new Date(minDate);
  //   startOfWeek.setDate(minDate.getDate() - ((minDate.getDay() + 6) % 7));
  //   const endOfWeek = new Date(startOfWeek);
  //   endOfWeek.setDate(startOfWeek.getDate() + 6);

  //   return dates.every((d) => d >= startOfWeek && d <= endOfWeek);
  // };
const validateWDSSelection = (rows) => {
  if (rows.length < 2) return false;

  // only WDS
  if (!rows.every((r) => r.form_type === "WDS")) return false;

  // same employee only
  const empSet = new Set(rows.map((r) => r.emp_id));
  if (empSet.size !== 1) return false;

  // no weekly restriction anymore
  return true;
};
  useEffect(() => {
    const selected = filteredData.filter((r) => selectedRows.includes(r.id));
    setShowMergeBtn(validateWDSSelection(selected));
  }, [selectedRows, filteredData]);

  const handleViewForm = (row) => {
    setRowData(row);
    setFormView(true);
  };

  const resetSelection = () => {
    setSelectedRows([]);
    setShowMergeBtn(false);
  };
const getEmployeeDateFilteredRows = () => {
  console.log("Selected Employee:", selectedEmployee);
  console.log("Selected Date Range:", selectedDateRange);

  if (!selectedEmployee || !selectedDateRange.startDate || !selectedDateRange.endDate) {
    console.log("No employee or date range selected, returning empty array.");
    return [];
  }

  const match = selectedEmployee.match(/(.*) \((.*)\)/);
  if (!match) {
    console.log("Failed to parse employee string:", selectedEmployee);
    return [];
  }

  const [empName, empId] = match.slice(1);
  const empIdNumber = Number(empId);

  // Make sure start and end are dayjs objects
  const start = dayjs(selectedDateRange.startDate);
  const end = dayjs(selectedDateRange.endDate);
  if (!start.isValid() || !end.isValid()) {
    console.error("Invalid date range:", selectedDateRange);
    return [];
  }

  const filtered = tableData.filter((row) => {
    console.log("Checking row:", row.id, row.emp_name, row.emp_id, row.filled_date);

    if (row.form_type !== "WDS") {
      console.log("Skipping row (not WDS):", row.id);
      return false;
    }

    if (row.emp_name !== empName || row.emp_id !== empIdNumber) {
      console.log("Skipping row (employee mismatch):", row.id);
      return false;
    }

    // Ensure rowDate is dayjs object
    const rowDate = dayjs(row.filled_date);
    if (!rowDate.isValid()) {
      console.log("Skipping row (invalid row date):", row.id, row.filled_date);
      return false;
    }

    const isInRange = rowDate.isSameOrAfter(start, "day") && rowDate.isSameOrBefore(end, "day");
    console.log(`Row ${row.id} date check: ${rowDate.format("YYYY-MM-DD")} in range?`, isInRange);

    return isInRange;
  });

  console.log("Filtered rows:", filtered.map((r) => r.id));
  return filtered;
};

const generateReport = () => {
  let rows = getEmployeeDateFilteredRows();

  // ❌ Remove already merged forms
  rows = rows.filter(
    (row) => !row.json_data?.some((obj) => obj.Dates)
  );

  if (rows.length < 2) {
    setOpen(true);
    setSeverity("error");
    setAlertMessage("Not enough forms to merge!");
    return;
  }

  setPreviewRows(rows);
  setModalSelectedRows(rows.map((r) => r.id)); // select all
  setOpenMergePreview(true);
};

const toggleModalRow = (id) => {
  setModalSelectedRows(prev =>
    prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
  );
};
const handleModalMerge = () => {
  let rowsToMerge = previewRows.filter(r => modalSelectedRows.includes(r.id));

  // ignore merged again (double safety)
  rowsToMerge = rowsToMerge.filter(
    (row) => !row.json_data?.some((obj) => obj.Dates)
  );

  if (rowsToMerge.length < 2) {
    setOpen(true);
    setSeverity("error");
    setAlertMessage("Select at least 2 valid forms");
    return;
  }

  mergeEmployeeDateForms(rowsToMerge);
};


const mergeEmployeeDateForms = async (rowsToMerge) => {
  if (rowsToMerge.length < 2) return;

  try {
    setLoader(true);

    const dates = rowsToMerge.map(r => r.filled_date);
    const minDate = dayjs.min(dates.map(d => dayjs(d)));
    const maxDate = dayjs.max(dates.map(d => dayjs(d)));
    const range = `${minDate.format("YYYY-MM-DD")} - ${maxDate.format("YYYY-MM-DD")}`;

    const data = [
      ...rowsToMerge,
      { type: "WDSMERGE" },
      { Dates: range }
    ];

    const response = await api.post("/v1/forms/create-form", {
      emp_id: rowsToMerge[0].emp_id,
      emp_name: rowsToMerge[0].emp_name,
      companyid: rowsToMerge[0].companyid,
      form_type: "WDS",
      job_id: rowsToMerge[0].job_id,
      job_description: rowsToMerge[0].jobDescription,
      observer_name: rowsToMerge[0].emp_name,
      filled_date: rowsToMerge[0].filled_date,
      json_data: data,
      documents: "",
      method: rowsToMerge[0].method
    });

    if (response.status === 200) {
      setAlertMessage("Forms merged successfully!");
      setSeverity("success");
      setOpen(true);
      setOpenMergePreview(false);
      fetchTableData();
    } else {
      throw new Error();
    }
  } catch {
    setAlertMessage("Something went wrong!");
    setSeverity("error");
    setOpen(true);
  } finally {
    setLoader(false);
  }
};

 const mergeForms = async () => {
  if (selectedRows.length < 2) return; // Safety check
  try {
    setLoader(true);

    // 1️⃣ Get selected objects
    const selectedObjs = filteredData.filter((r) => selectedRows.includes(r.id));

    // 2️⃣ Prepare date range
    const dates = selectedObjs.map((r) => r.filled_date);
    const minDate = dayjs.min(dates.map(d => dayjs(d)));
    const maxDate = dayjs.max(dates.map(d => dayjs(d)));
    const range = `${minDate.format("YYYY-MM-DD")} - ${maxDate.format("YYYY-MM-DD")}`;

    // 3️⃣ Build json_data for merged form
    const data = [
      ...selectedObjs,
      { type: "WDSMERGE" },
      { Dates: range }
    ];

    // 4️⃣ Call API to create merged form
    const response = await api.post("/v1/forms/create-form", {
      emp_id: selectedObjs[0].emp_id,
      emp_name: selectedObjs[0].emp_name,
      companyid: selectedObjs[0].companyid,
      form_type: "WDS",
      job_id: selectedObjs[0].job_id,
      job_description: selectedObjs[0].jobDescription,
      observer_name: selectedObjs[0].emp_name,
      filled_date: selectedObjs[0].filled_date,
      json_data: data,
      documents: "",
      method: selectedObjs[0].method
    });

    // 5️⃣ Handle response
    if (response.status === 200) {
      setOpen(true);
      setSeverity("success");
      setAlertMessage("Forms merged successfully!");
      fetchTableData(); // refresh table
    } else {
      setOpen(true);
      setSeverity("error");
      setAlertMessage("Something went wrong!");
    }

  } catch (error) {
    setOpen(true);
    setSeverity("error");
    setAlertMessage("Something went wrong!");
    console.error("Merge error:", error);
  } finally {
    resetSelection();
    setLoader(false);
  }
};

  const isGenerateEnabled =
    selectedEmployee && selectedDateRange.startDate && selectedDateRange.endDate;

 
const isAllSelected =
  previewRows.length > 0 && modalSelectedRows.length === previewRows.length;

const isIndeterminate =
  modalSelectedRows.length > 0 &&
  modalSelectedRows.length < previewRows.length;

const handleSelectAllChange = () => {
  if (isAllSelected) {
    setModalSelectedRows([]);
  } else {
    setModalSelectedRows(previewRows.map(r => r.id));
  }
};

  return (
    <SideNavLayout>
      <div className="flex flex-col p-4 max-h-[90vh] overflow-y-auto relative">
      <div className="flex items-center mb-4 gap-3">
  <FontAwesomeIcon
    onClick={() => Navigate(-1)}
    icon={faArrowLeft}
    className="text-2xl cursor-pointer text-black"
  />
  <div className="text-2xl font-bold">{formTypeMap[typeParam]}</div>
</div>

       

        {/* Universal search */}
        <div className="relative w-full max-w-sm mb-3">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search employee, job, form, method, observer..."
            className="w-full border-2 border-[#E4E4E7] rounded-md px-3 py-2 bg-white text-sm text-black focus:outline-none focus:border-[#8B1818]"
          />
          {searchTerm && (
            <button
              type="button"
              onClick={() => setSearchTerm("")}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-sm"
              aria-label="Clear search"
            >
              ✕
            </button>
          )}
        </div>

        {/* Employee + Calendar + Generate */}
        <div className="flex flex-col md:flex-row gap-4 items-center mb-4 relative">
          <select
            className="border px-3 py-2 rounded"
            value={selectedEmployee}
            onChange={(e) => setSelectedEmployee(e.target.value)}
          >
            <option value="">Select Employee</option>
            {[...new Set(tableData.map(row => `${row.emp_name} (${row.emp_id})`))].map(emp => (
              <option key={emp} value={emp}>{emp}</option>
            ))}
          </select>

          <div className="relative flex items-center gap-2">
  <div
    className={`flex bg-white items-center gap-2 border border-gray-300 py-1 px-3 rounded cursor-pointer`}
    onClick={() => setOpenCalendar(true)}
  >
    <img src={Calendar1} alt="calendar" className="w-5 h-5" />
    <span className="text-[#293050] font-inter text-sm">
      {dayjs(selectedDateRange.startDate).format("MMM DD, YYYY")} - {dayjs(selectedDateRange.endDate).format("MMM DD, YYYY")}
    </span>
  </div>
<div className="absolute ">
 <CalendarDropdown
    open={openCalendar}
    setOpen={setOpenCalendar}
    selectedDateRange={selectedDateRange}
    setSelectedDateRange={setSelectedDateRange}
  />

</div>
 
</div>


          <button
            className={`px-4 py-2 rounded text-white ${
              isGenerateEnabled ? "bg-black hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
            }`}
            disabled={!isGenerateEnabled}
            onClick={generateReport}
          >
            Generate Report
          </button>

        
        </div>

        {/* Merge Button */}
        {showMergeBtn && selectedRows.length > 1 && (
          <div className="flex justify-end mb-3">
            <button className="bg-black text-white px-4 py-2 rounded" onClick={mergeForms}>
              Merge Forms
            </button>
          </div>
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-xl shadow-md border border-gray-200">
          <table className="w-full min-w-[900px] bg-white text-left rounded-xl">
            <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
              <tr>
                <th className="p-3 text-center"> </th>
                <th
                  onClick={() => setActiveModal("date")}
                  className="cursor-pointer p-3 text-left"
                >
                  <div className="flex items-center gap-1">
                    Date <KeyboardArrowDownIcon fontSize="small" />
                  </div>
                </th>
                <th
                  onClick={() => setActiveModal("employee")}
                  className="cursor-pointer p-3 text-left"
                >
                  <div className="flex items-center gap-1">
                    Employee <KeyboardArrowDownIcon fontSize="small" />
                  </div>
                </th>
                <th
                  onClick={() => setActiveModal("job")}
                  className="cursor-pointer p-3 text-left"
                >
                  <div className="flex items-center gap-1">
                    Job <KeyboardArrowDownIcon fontSize="small" />
                  </div>
                </th>
                <th
                  onClick={() => setActiveModal("form")}
                  className="cursor-pointer p-3 text-left"
                >
                  <div className="flex items-center gap-1">
                    Form <KeyboardArrowDownIcon fontSize="small" />
                  </div>
                </th>
                <th
                  onClick={() => setActiveModal("method")}
                  className="cursor-pointer p-3 text-left"
                >
                  <div className="flex items-center gap-1">
                    Method <KeyboardArrowDownIcon fontSize="small" />
                  </div>
                </th>
                <th className="p-3 text-left">Observer</th>
                <th
                  onClick={() => setActiveModal("status")}
                  className="cursor-pointer p-3 text-left"
                >
                  <div className="flex items-center gap-1">
                    Status <KeyboardArrowDownIcon fontSize="small" />
                  </div>
                </th>
                <th className="p-3 text-center">Action</th>
              </tr>
            </thead>

            <tbody className="text-sm text-gray-800">
              {filteredData.length > 0 ? (
                [...filteredData].reverse().map((row) => (
                  <tr key={row.id} className="border-t hover:bg-gray-50">
                    <td className="text-center p-2">
                    {row.form_type === "WDS" && !row.json_data?.some(obj => obj.type === "WDSMERGE") && (
  <input
    type="checkbox"
    checked={selectedRows.includes(row.id)}
    onChange={() => handleCheckboxChange(row.id)}
  />
)}

                    </td>
                    <td className="p-2">{row.json_data?.find(obj => obj.Dates)?.Dates || row.filled_date}</td>
                    <td className="p-2">{`${row.emp_name} (${row.emp_id})`}</td>
                    <td className="p-2">{`${row.jobDescription} (${row.job_id})`}</td>
                    <td className="p-2">{row.form_type}</td>
                    <td className="p-2">{row.method || "-"}</td>
                    <td className="p-2">{row.observer_name}</td>
                    <td className="p-2">{row.status === "A" ? "Completed" : "Pending"}</td>
                    <td className="p-2 text-center">
                      <div
                        className="bg-[#1E4976] w-9 h-9 cursor-pointer text-white flex items-center justify-center rounded hover:bg-blue-700"
                        onClick={() => handleViewForm(row)}
                      >
                        <RemoveRedEyeIcon fontSize="small" />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-6 text-gray-600">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Filter Modals */}
        {activeModal === "date" && (
          <FilterModal
            label="Date"
            dataList={[...new Set(tableData.map(row => row.json_data?.find(obj => obj.Dates)?.Dates || row.filled_date))]}
            selectedValues={selectedFilters.dates}
            onSave={(values) => setSelectedFilters(prev => ({ ...prev, dates: values }))}
            onClose={() => setActiveModal(null)}
          />
        )}
        {activeModal === "employee" && (
          <FilterModal
            label="Employee"
            dataList={[...new Set(tableData.map(row => `${row.emp_name} (${row.emp_id})`))]}
            selectedValues={selectedFilters.employees}
            onSave={(values) => setSelectedFilters(prev => ({ ...prev, employees: values }))}
            onClose={() => setActiveModal(null)}
          />
        )}
        {activeModal === "job" && (
          <FilterModal
            label="Job"
            dataList={[...new Set(tableData.map(row => `${row.jobDescription} (${row.job_id})`))]}
            selectedValues={selectedFilters.jobs}
            onSave={(values) => setSelectedFilters(prev => ({ ...prev, jobs: values }))}
            onClose={() => setActiveModal(null)}
          />
        )}
        {activeModal === "form" && (
          <FilterModal
            label="Form Type"
            dataList={[...new Set(tableData.map(row => row.form_type))]}
            selectedValues={selectedFilters.formTypes}
            onSave={(values) => setSelectedFilters(prev => ({ ...prev, formTypes: values }))}
            onClose={() => setActiveModal(null)}
          />
        )}
        {activeModal === "method" && (
          <FilterModal
            label="Method"
            dataList={[...new Set(tableData.map(row => row.method))]}
            selectedValues={selectedFilters.methods}
            onSave={(values) => setSelectedFilters(prev => ({ ...prev, methods: values }))}
            onClose={() => setActiveModal(null)}
          />
        )}
        {activeModal === "status" && (
          <FilterModal
            label="Status"
            dataList={["A", "P"]}
            selectedValues={selectedFilters.statuses}
            onSave={(values) => setSelectedFilters(prev => ({ ...prev, statuses: values }))}
            onClose={() => setActiveModal(null)}
            labelMap={{ A: "Completed", P: "Pending" }}
          />
        )}

        {/* Form View Modals */}
        {formView && rowData && (
          <>
            {rowData.form_type === "WDS" &&
              (rowData?.json_data?.some(obj => obj.Dates) ? (
                <WDSMergeFormModal
                  formType={rowData.form_type}
                  rowData={rowData}
                  setFormView={setFormView}
                />
              ) : (
                <WDSFormModal
                  formType={rowData.form_type}
                  rowData={rowData}
                  setFormView={setFormView}
                />
              ))}
            {rowData.form_type === "WDLS" && (
              <WDSFormModal
                formType={rowData.form_type}
                rowData={rowData}
                setFormView={setFormView}
              />
            )}
          </>
        )}

        {/* Loader */}
        <Backdrop open={loader} sx={{ color: "#fff", zIndex: 1000 }}>
          <CircularProgress color="inherit" />
        </Backdrop>

        {/* Toast */}
        <ToastMessage
          message={alertMessage}
          severity={severity}
          open={open}
          handleClose={() => setOpen(false)}
        />
      </div>
{openMergePreview && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white w-[750px] max-h-[85vh] rounded-lg shadow-lg flex flex-col">
      
      {/* Header */}
   <div className="p-4 border-b flex items-center justify-between">
  <div className="flex items-center gap-3">
    {/* Select All checkbox */}
    <input
      type="checkbox"
      checked={isAllSelected}
      ref={el => {
        if (el) el.indeterminate = isIndeterminate;
      }}
      onChange={handleSelectAllChange}
    />

    <div className="font-semibold text-lg">
      Forms to be merged ({modalSelectedRows.length})
    </div>
  </div>
</div>


      {/* Scroll List */}
      <div className="p-4 overflow-y-auto flex-1">
        {previewRows.map((row) => (
          <div
            key={row.id}
            className="border rounded p-3 mb-2 flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={modalSelectedRows.includes(row.id)}
                onChange={() => toggleModalRow(row.id)}
              />

              <div>
                <div className="font-medium">
                  {row.emp_name} ({row.emp_id})
                </div>
                <div className="text-sm text-gray-600">
                  {row.filled_date}
                </div>
              </div>
            </div>

            <div className="text-sm">
              {row.jobDescription}
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="p-4 border-t flex justify-end gap-3">
        <button
          className="px-4 py-2 border rounded"
          onClick={() => setOpenMergePreview(false)}
        >
          Cancel
        </button>

        <button
          className="bg-black text-white px-6 py-2 rounded disabled:bg-gray-400"
          disabled={modalSelectedRows.length < 2}
          onClick={handleModalMerge}
        >
          Merge Selected
        </button>
      </div>
    </div>
  </div>
)}


    </SideNavLayout>
  );
};

export default MergeDashboard;
